import React, { useState, useEffect } from 'react';
import classes from '../Preguntas.css';

export default function PreguntaMultiselect({
  PreguntasOpciones,
  valorDefault = [],
  numeroPregunta,
  onChangeRespuesta,
  onElegir,
  esObligatoria,
  seleccionUnica = false // 🔸 Prop para determinar el tipo de selección
}) {
  const [selectedValues, setSelectedValues] = useState(Array.isArray(valorDefault) ? valorDefault : []);

  // Sincroniza con el valorDefault si cambia
  useEffect(() => {
    const nuevoValor = Array.isArray(valorDefault) ? valorDefault : [];
    const idsSeleccionados = selectedValues.map((item) => item[0]);
    const idsDefault = nuevoValor.map((item) => item[0]);

    const sonIguales =
      idsSeleccionados.length === idsDefault.length && idsSeleccionados.every((id) => idsDefault.includes(id));

    if (!sonIguales) {
      setSelectedValues(nuevoValor);
    }
  }, [valorDefault]);

  const elegir = (opcion) => {
    const value = [opcion.id, opcion.opcion];
    if (seleccionUnica) {
      if (selectedValues[0]?.[0] !== opcion.id) {
        setSelectedValues([value]);
      }
      onElegir?.();
      return;
    }
    setSelectedValues((prevSelected) =>
      prevSelected.some((item) => item[0] === opcion.id)
        ? prevSelected.filter((item) => item[0] !== opcion.id)
        : [...prevSelected, value]
    );
  };

  useEffect(() => {
    const respuesta = {
      numeroPregunta,
      tieneContenido: selectedValues.length > 0,
      contenido: selectedValues,
      esObligatoria
    };
    onChangeRespuesta(respuesta);
  }, [selectedValues]);

  return (
    <div className={classes.sino}>
      {(PreguntasOpciones ?? []).map((opcion) => {
        const seleccionada = selectedValues.some((item) => item[0] === opcion.id);
        return (
          <button
            key={opcion.id}
            type="button"
            className={seleccionada ? classes.sel : ''}
            aria-pressed={seleccionada}
            onClick={() => elegir(opcion)}
          >
            {String(opcion.opcion ?? '').trim()}
          </button>
        );
      })}
    </div>
  );
}
